import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const HeaderContainer = styled(motion.header)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 1rem 2rem;
  background: ${props => props.scrolled ? 'rgba(15, 15, 35, 0.95)' : 'transparent'};
  backdrop-filter: ${props => props.scrolled ? 'blur(10px)' : 'none'};
  transition: all 0.3s ease;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const Logo = styled(motion.div)`
  font-size: 1.5rem;
  font-weight: bold;
  color: #00d4ff;
  cursor: pointer;
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(motion.li)`
  a {
    color: #ffffff;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;
    
    &:hover {
      color: #00d4ff;
    }
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #ffffff;
  font-size: 1.5rem;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <HeaderContainer
      scrolled={scrolled}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Nav>
        <Logo
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          SM
        </Logo>
        <NavLinks>
          <NavLink whileHover={{ y: -2 }}>
            <a href="#home">Home</a>
          </NavLink>
          <NavLink whileHover={{ y: -2 }}>
            <a href="#about">About</a>
          </NavLink>
          <NavLink whileHover={{ y: -2 }}>
            <a href="#skills">Skills</a>
          </NavLink>
          <NavLink whileHover={{ y: -2 }}>
            <a href="#experience">Experience</a>
          </NavLink>
          <NavLink whileHover={{ y: -2 }}>
            <a href="#projects">Projects</a>
          </NavLink>
          <NavLink whileHover={{ y: -2 }}>
            <a href="#contact">Contact</a>
          </NavLink>
        </NavLinks>
        <MobileMenuButton>☰</MobileMenuButton>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;